import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js' // 确保Element UI先引入
import * as XLSX from 'xlsx'
window.XLSX = XLSX // 全局挂载XLSX供Excel解析使用
import VueEasytable from "vue-easytable";
import globalFuncs from './utils/global-funcs'
Vue.prototype.$utils = globalFuncs;

// 引入样式
import "vue-easytable/libs/theme-default/index.css";
import "vue-easytable/libs/theme-default/ve-pagination.css";
import JsonViewer from 'vue-json-viewer';
import { confirmDialog } from './utils/confirm'

Vue.use(JsonViewer);
Vue.use(VueEasytable);
// 注册全局Loading组件
import AjLoading from './components/AjLoading/index.js'
Vue.use(AjLoading)
import ajTable from './components/ajTable/ajTable.vue';
Vue.component('ajTable', ajTable)
import myUpload from './components/myUpload/my-upload.vue';
Vue.component('myUpload', myUpload)
import ajFormAdd from './components/ajForm/ajFormAdd.vue';
Vue.component('ajFormAdd', ajFormAdd)
import ajFormEdit from './components/ajForm/ajFormEdit.vue';
Vue.component('ajFormEdit', ajFormEdit)
import ajFormDetail from './components/ajForm/ajFormDetail.vue';
Vue.component('ajFormDetail', ajFormDetail)



import { VeLocale } from "vue-easytable";
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.prototype.$veLocale = VeLocale;
router.beforeEach((to, from, next) => {
    if (to.path === '/doLogin') {
        next();
    }else if (to.path === '/Home/lecturerResource/lecturerResource') {
        next('/Home/lecturerResource');
    } else {
        let userid =localStorage.getItem('zhikeTong_token');
        if (userid) {
            next();
        } else {
            console.log('1');
            
            next('/doLogin');
        }
    }
});

// 1. 先创建Vue实例并赋值给window.vm（关键！）
const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
window.vm = vm // 让工具函数能拿到全局Vue实例

// 2. 全局注册confirmDialog，绑定this指向组件实例（核心！）
Vue.prototype.$confirmDialog = function(options) {
  // 把confirmDialog的this绑定到当前组件实例
  return confirmDialog.call(this, options)
}

// 路由守卫放在最后（不影响核心逻辑）
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
let flagShow = false
if(flag){
    flagShow = true
}
